import { render, staticRenderFns } from "./FinalDashboard.vue?vue&type=template&id=f1138bd0&"
import script from "./FinalDashboard.vue?vue&type=script&lang=js&"
export * from "./FinalDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports